import { useEffect, useState } from "react";
function usePaperWidth($root) {
  const [width, setWidth] = useState(() => 0);
  useEffect(() => {
    if (!$root) return;
    const updateWidth = () => {
      setWidth($root.offsetWidth ?? 0);
    };
    updateWidth();
    const observer = new MutationObserver(updateWidth);
    observer.observe($root, { attributes: true, childList: true, subtree: true });
    return () => {
      observer.disconnect();
    };
  }, [$root]);
  return width;
}
export {
  usePaperWidth
};
//# sourceMappingURL=usePaperWidth.js.map
